import { useState } from 'react';
import Reveal from '../Components/Reveal';
import '../styles/Contact.css';
import waterPowerImg from '../Assets/water power.jpg';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', organization: '', solution: 'Digital & Data Solutions', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${BACKEND_URL}/api/contact/energy`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Something went wrong.');
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Failed to send. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ── HERO ── */}
      <section className="ew-contact-hero">
        <div className="ew-contact-hero__inner">
          <div className="ew-contact-hero__card">
            <img
              src={waterPowerImg}
              alt="Office Workspace"
              className="ew-contact-hero__img"
            />
            <div className="ew-contact-hero__overlay">
              <span className="ew-contact-hero__eyebrow">Get In Touch</span>
              <h1 className="ew-contact-hero__heading">
                Let's Build the Future of<br />Energy Intelligence
              </h1>
            </div>
          </div>
        </div>
      </section>

      {/* ── CONTACT FORM & INFO ── */}
      <section className="ew-contact-main">
        <div className="ew-contact-main__inner">
          <div className="ew-contact-main__grid">

            {/* Left: Info */}
            <Reveal delay={0}>
              <div className="ew-contact-info">
                <h2 className="ew-contact-info__heading">Connect with our Experts</h2>
                <p className="ew-contact-info__body">
                  Ready to transform your data chaos into strategic intelligence?
                  Our team is available to discuss custom enterprise solutions,
                  technical studies, or specialized training programs.
                </p>

                <div className="ew-contact-info__items">
                  <div className="ew-contact-info__item">
                    <div className="ew-contact-info__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
                        <circle cx="12" cy="10" r="3"/>
                      </svg>
                    </div>
                    <div>
                      <h4 className="ew-contact-info__item-title">Headquarters (Malaysia)</h4>
                      <p className="ew-contact-info__item-body">
                        Suite 12, WORQ Sunway Putra,<br />
                        Level 4-1, Sunway Putra Mall,<br />
                        100, Jalan Putra, Chow Kit,<br />
                        50350 Kuala Lumpur,<br />
                        W.P. Kuala Lumpur, Malaysia
                      </p>
                    </div>
                  </div>

                  <div className="ew-contact-info__item">
                    <div className="ew-contact-info__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
                        <circle cx="12" cy="10" r="3"/>
                      </svg>
                    </div>
                    <div>
                      <h4 className="ew-contact-info__item-title">Regional Office (Australia)</h4>
                      <p className="ew-contact-info__item-body">
                        40/57 Frederick Street,<br />
                        Belmont, 6104,<br />
                        Western Australia, Australia
                      </p>
                    </div>
                  </div>

                  <div className="ew-contact-info__item">
                    <div className="ew-contact-info__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect width="20" height="16" x="2" y="4" rx="2"/>
                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                      </svg>
                    </div>
                    <div>
                      <h4 className="ew-contact-info__item-title">Inquiries</h4>
                      <p className="ew-contact-info__item-body">
                        connect@teczo.co<br />Response time: Within 24 hours
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>

            {/* Right: Form */}
            <Reveal delay={150}>
              <div className="ew-contact-form-wrap">
                {submitted ? (
                  <div style={{ textAlign: 'center', padding: '3rem 1rem' }}>
                    <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '1rem' }}><path d="M20 6 9 17l-5-5"/></svg>
                    <h3 style={{ fontSize: '1.5rem', fontWeight: 900, marginBottom: '0.5rem' }}>Message Sent!</h3>
                    <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>Thank you for reaching out. We'll get back to you within 24 hours.</p>
                    <button
                      onClick={() => { setSubmitted(false); setForm({ name: '', email: '', organization: '', solution: 'Digital & Data Solutions', message: '' }); }}
                      style={{ background: 'none', border: 'none', color: '#10b981', fontWeight: 700, cursor: 'pointer', fontSize: '0.9rem' }}
                    >
                      Send another message
                    </button>
                  </div>
                ) : (
                  <form className="ew-contact-form" onSubmit={handleSubmit}>
                    <div className="ew-contact-form__row">
                      <div className="ew-contact-form__field">
                        <label className="ew-contact-form__label">Full Name *</label>
                        <input name="name" type="text" placeholder="John Doe" required className="ew-contact-form__input" value={form.name} onChange={handleChange} />
                      </div>
                      <div className="ew-contact-form__field">
                        <label className="ew-contact-form__label">Work Email *</label>
                        <input name="email" type="email" placeholder="john@company.com" required className="ew-contact-form__input" value={form.email} onChange={handleChange} />
                      </div>
                    </div>

                    <div className="ew-contact-form__field">
                      <label className="ew-contact-form__label">Organization</label>
                      <input name="organization" type="text" placeholder="Energy Corp" className="ew-contact-form__input" value={form.organization} onChange={handleChange} />
                    </div>

                    <div className="ew-contact-form__field">
                      <label className="ew-contact-form__label">Interested Solution</label>
                      <select name="solution" className="ew-contact-form__input ew-contact-form__select" value={form.solution} onChange={handleChange}>
                        <option>Digital &amp; Data Solutions</option>
                        <option>Engineering Support</option>
                        <option>Capability Development</option>
                        <option>Product Demo (DocuNest / EnergyStudio)</option>
                        <option>Others</option>
                      </select>
                    </div>

                    <div className="ew-contact-form__field">
                      <label className="ew-contact-form__label">Message *</label>
                      <textarea name="message" rows="4" placeholder="How can we help your team?" required className="ew-contact-form__input ew-contact-form__textarea" value={form.message} onChange={handleChange} />
                    </div>

                    {error && <p style={{ color: '#ef4444', fontSize: '0.875rem', fontWeight: 600, marginBottom: '0.5rem' }}>{error}</p>}

                    <button type="submit" className="ew-contact-form__submit" disabled={loading}>
                      {loading ? 'Sending...' : 'Send Request'}
                    </button>
                  </form>
                )}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ── WHY WORK WITH US ── */}
      <section className="ew-contact-why">
        <div className="ew-contact-why__inner">
          <Reveal delay={0}>
            <div className="ew-contact-why__header">
              <p className="ew-contact-why__eyebrow">Why EnergyWorks</p>
              <h2 className="ew-contact-why__heading">Built for Energy. Driven by Results.</h2>
              <p className="ew-contact-why__sub">
                From Malaysia to Australia, our team brings deep domain expertise and
                battle-tested digital solutions to every engagement.
              </p>
            </div>
          </Reveal>
          <div className="ew-contact-why__grid">
            <Reveal delay={80}>
              <div className="ew-contact-why__card">
                <div className="ew-contact-why__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  </svg>
                </div>
                <h4 className="ew-contact-why__card-title">Industry-Proven</h4>
                <p className="ew-contact-why__card-body">
                  Trusted by PETRONAS, UTP, and leading energy firms across the ASEAN region and Australia.
                </p>
              </div>
            </Reveal>
            <Reveal delay={160}>
              <div className="ew-contact-why__card">
                <div className="ew-contact-why__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>
                  </svg>
                </div>
                <h4 className="ew-contact-why__card-title">AI-First Approach</h4>
                <p className="ew-contact-why__card-body">
                  Purpose-built AI solutions trained on energy-specific datasets — not generic tools adapted for the industry.
                </p>
              </div>
            </Reveal>
            <Reveal delay={240}>
              <div className="ew-contact-why__card">
                <div className="ew-contact-why__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/>
                  </svg>
                </div>
                <h4 className="ew-contact-why__card-title">Measurable Impact</h4>
                <p className="ew-contact-why__card-body">
                  Our engagements deliver quantifiable outcomes — from 80% reduction in manual extraction to 40% cost savings.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
